
/** SSO restrict */
export enum SSORestrictType {
    // DINGTLK、WECHAT_ENTERPRISE、FEISHU、JWT、UNKNOWN
    DINGTLK = 'DINGTLK',
    WECHAT_ENTERPRISE = 'WECHAT_ENTERPRISE',
    FEISHU = 'FEISHU',
    JWT = 'JWT',
    UNKNOWN = 'UNKNOWN'
  }

/** 登录方式 */
export enum LoginMethod {
    password = 'EMAIL_PASSWORD',
    mobilePassword = 'MOBILE_PASSWORD',
    sms = 'MOBILE_VERIFY_CODE',
    carsi = 'carsi',
    wechat = 'WECHAT_QR_CODE',
    emailVerifyCode = 'EMAIL_VERIFY_CODE',
    google = 'GOOGLE'
}

/** 获取租户信息请求参数 */
export interface PostTenantSelectInfosParams {
    email?: string;
    country_code?: string;
    mobile?: string;
    password?: string;
    verify_code?: string;
    identify_token?: string;
    google_id_token?: string;
    login_method_enum?: LoginMethod;
  }

/** 租户信息 */
export interface PostTenantSelectInfosItem {
    tenant_id: string;
    tenant_name: string;
    domain_restrict?: boolean;
    ip_restrict?: boolean;
    sso_restrict?: boolean;
    sso_restrict_type?: SSORestrictType;
    login_url?: string;
    individual?: boolean;
    default_selected?: boolean;
    /**
     * 用户在当前租户是否激活或者可以跳过邮箱验证
     */
    account_status_active?: boolean;
  }
